


















































































import { Component, Prop, Vue } from "vue-property-decorator";
import Layout from "@/components/Layout.vue"; // @ is an alias to /src
import AssignCard from "@/components/common/AssignCard.vue";
import MainSlogan from "@/components/common/MainSlogan.vue";
import WordOnPic from "@/components/common/WordOnPic.vue";
import PicWall from "@/components/common/PicWall.vue";
import AppArea from "@/components/common/AppArea.vue";
@Component({
  components: {
    Layout,
    AssignCard,
    MainSlogan,
    WordOnPic,
    PicWall,
    AppArea,
  },
})
export default class ZChome extends Vue {
  data() {
    return {
      bg: require("@/assets/storage/img/bg.png"),
      stwo: require("@/assets/storage/img/stwo.png"),
      sthree: require("@/assets/storage/img/sthree.png"),
      sfour: require("@/assets/storage/img/sfour.png"),
      sfive: require("@/assets/storage/img/sfive.png"),
    };
  }
  navigate(path: string) {
    this.$router.push({
      path,
    });
  }
  goZCPowerwall() {
    this.$router.push({
      path: "/zeroCarbon/zchome/powerwall",
    });
  }
  goChargePile() {
    this.$router.push({
      path: "/zeroCarbon/zchome/chargepile",
    });
  }
}
